export const operators = {
  or: 1,
  and: 2,
}

export function getPriority(op) {
  return operators[op.operator] ? operators[op.operator] : 0
}

export function isOperator(item) {
  return item.type === 'operator'
}

export const getReverse = (arr) => arr.slice().reverse()
